import React from 'react';

// Bande bicolore de chantier. Motif recurrent de l'identite.
export default function Bande({ hauteur = 8, claire = false, anime = false, className = '' }) {
  return (
    <div
      aria-hidden="true"
      className={`w-full ${claire ? 'bande-chantier-claire' : 'bande-chantier'} ${
        anime ? 'animate-defile' : ''
      } ${className}`}
      style={{ height: hauteur }}
    />
  );
}
